var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Productos")]),_c('List',{attrs:{"items":_vm.products,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }